export default __webpack_public_path__ + "static/media/sandwich.4b22450e.svg";